import { Service } from '@roc/feature-app-core';

const url = {
  GET_TITLE_COMPANIES_BY_LENDER:
    '/api/v1/document/formDocument/getTitleAgenciesByLenderId',
  UPDATE_TITLE_AGENT_FORM: '/api/v1/document/formDocument/updateTitleAgentForm',
};

export class TitleAgentV2Service extends Service {
  getTitleCompaniesByLender = (lenderId: number) => {
    return this.get(url.GET_TITLE_COMPANIES_BY_LENDER, { lenderId });
  };

  updateTitleAgentForm = payload => {
    return this.put(url.UPDATE_TITLE_AGENT_FORM, payload);
  };

  addContactToCompany = (companyId: number, contact: any) => {
    return this.post('/api/v1/companies/saveCompanyContact', { companyId, ...contact });
  };
}
